import {useCallback, useState} from "react";

export interface UseDeleteDialogOptions {
  deleteMiddleware: () => Promise<any>
}
export const useDeleteDialog = ({ deleteMiddleware }: UseDeleteDialogOptions) => {
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const handleConfirm = useCallback(async () => {
    await deleteMiddleware()
    setIsOpenDelete(true)
  }, [deleteMiddleware])
  const handleClose = useCallback(() => {
    setIsOpenDelete(false)
  }, [])
  const handleOpen = useCallback(() => {
    setIsOpenDelete(true)
  }, [])

  return {
    isOpenDelete,
    handleConfirm,
    handleClose,
    handleOpen
  }
}
